export const contact = {
  name: 'Andrea Báez Graterol',
  brandTop: 'ANDREA BÁEZ',
  brandBottom: 'INSURANCE',
  title: 'Insurance Advisor',
  npn: 'NPN 20885017',
  phoneDisplay: '954-644-5825',
  phoneHref: 'tel:+19546445825',
  whatsapp:
    'https://wa.me/19546445825?text=Hola%20Andrea%2C%20me%20gustar%C3%ADa%20conocer%20mis%20opciones%20de%20seguro.',
  email: 'andreabaezinsurance@gmail.com',
  emailHref: 'mailto:andreabaezinsurance@gmail.com',
  instagram: '@andreabaezinsurance',
  instagramHref: 'https://instagram.com/andreabaezinsurance',
  tagline: 'Protege tu presente. Construye tu futuro.',
}

export const navLinks = [
  { label: 'Inicio', href: '#inicio' },
  { label: 'Sobre mí', href: '#sobre-mi' },
  { label: 'Servicios', href: '#servicios' },
  { label: 'Compañías', href: '#companias' },
  { label: 'Testimonios', href: '#testimonios' },
  { label: 'Preguntas frecuentes', href: '#educacion' },
  { label: 'Contacto', href: '#contacto' },
]

export const heroImage =
  'https://cdn.magicpatterns.com/uploads/wqLKLBu5Eogew6Zb5ezG92/1.png'
export const aboutImage =
  'https://cdn.magicpatterns.com/uploads/stGoAxRhSaufzgQrfNebfp/2.jpg'
